





















import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { HighlightsButtonAction } from '@front-app/modules/group/highlights/model';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { computed, defineComponent, PropType } from '@vue/composition-api';

const ACTION_OPTION_LABELS = {
	[HighlightsButtonAction.LINK_EXTERNAL]: 'highlights-admin.button-action-external-link',
	[HighlightsButtonAction.LINK_EXTERNAL]: 'highlights-admin.button-action-external-link',
	[HighlightsButtonAction.VIEW_EXTERNAL_VIDEO]: 'highlights-admin.button-action-view-external-video',
	[HighlightsButtonAction.DOWNLOAD_FILE_INTERNAL]: 'highlights-admin.button-action-download-file-internal',
	[HighlightsButtonAction.DOWNLOAD_FILE_EXTERNAL]: 'highlights-admin.button-action-download-file-external',
	[HighlightsButtonAction.MESSAGE_USER]: 'highlights-admin.button-action-message-user',
	[HighlightsButtonAction.REFER_COLLEAGUE_TO_GROUP]: 'highlights-admin.button-action-refer-colleague-to-group',
	[HighlightsButtonAction.SUBMIT_SUGGESTION]: 'highlights-admin.button-action-submit-suggestion',
	[HighlightsButtonAction.START_QUIZ]: 'highlights-admin.button-action-start-quiz',
	[HighlightsButtonAction.CONTENT_SEARCH]: 'highlights-admin.button-action-content-search',
	[HighlightsButtonAction.VIEW_EVENT]: 'highlights-admin.button-action-event-link',
};

const ACTION_OPTIONS = [
	HighlightsButtonAction.LINK_EXTERNAL,
	HighlightsButtonAction.VIEW_EXTERNAL_VIDEO,
	HighlightsButtonAction.DOWNLOAD_FILE_INTERNAL,
	HighlightsButtonAction.DOWNLOAD_FILE_EXTERNAL,
	HighlightsButtonAction.MESSAGE_USER,
	HighlightsButtonAction.REFER_COLLEAGUE_TO_GROUP,
	HighlightsButtonAction.SUBMIT_SUGGESTION,
	HighlightsButtonAction.START_QUIZ,
	HighlightsButtonAction.CONTENT_SEARCH,
	HighlightsButtonAction.VIEW_EVENT,
];

export default defineComponent({
	components: {
		SelectBox,
	},
	props: {
		value: {
			type: String as PropType<HighlightsButtonAction>,
			default: null,
		},
	},
	setup(props, ctx) {
		const $t = useTranslate(ctx);

		// Actions
		const actionOptions = computed(() => ACTION_OPTIONS.map((key) => ({
			key,
			label: $t(ACTION_OPTION_LABELS[key]) as unknown as string,
		})));
		// End actions
		return {
			DropdownPosition,
			ACTION_OPTION_LABELS,
			actionOptions,
		};
	},
});
